
import Vue from 'vue'

const PALETTE: Record<string, { color: string; bg: string }> = {
  primary: { color: '#5b6af0', bg: '#eef0fd' },
  success: { color: '#16a34a', bg: '#dcfce7' },
  warning: { color: '#d97706', bg: '#fef3c7' },
  danger: { color: '#dc2626', bg: '#fee2e2' },
  info: { color: '#2563eb', bg: '#dbeafe' },
  purple: { color: '#7c3aed', bg: '#ede9fe' },
  gray: { color: '#6b7280', bg: '#f3f4f6' }
}

export default Vue.extend({
  name: 'StatCard',
  props: {
    title: { type: String, default: '' },
    value: { type: [Number, String], default: 0 },
    subtitle: { type: String, default: '' },
    icon: { type: String, default: 'mdi-chart-box-outline' },
    color: { type: String, default: 'primary' },
    loading: { type: Boolean, default: false }
  },
  computed: {
    accentColor (): string {
      return (PALETTE[this.color] || PALETTE.primary).color
    },
    accentBg (): string {
      return (PALETTE[this.color] || PALETTE.primary).bg
    },
    formattedValue (): string {
      if (typeof this.value === 'number') return this.value.toLocaleString('tr-TR')
      return String(this.value)
    }
  }
})
